import React from "react";
import { Navbar } from "../../Navbar/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { useGetInitialAppliedThemeQuery } from "../../../redux-toolkit/features/theme/themeApiSlice";
import { useGetCompletedAlphaScreensQuery } from "../../../redux-toolkit/features/auth/authApiSlice";
import ProgressBar from "../../UI/ProgressBar";
import { useDispatch } from "react-redux";
import { roleToggler } from "../../../redux-toolkit/features/access/accessSlice";

const EmployeeLayout = () => {
  const { pathname } = useLocation();
  const isTimeTrailsPage = pathname.includes("time-trails");
  const { data, isLoading, refetch } = useGetInitialAppliedThemeQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    },
  );
  const { refetch: alphaRefetch } = useGetCompletedAlphaScreensQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const dispatch = useDispatch();
  React.useEffect(() => {
    refetch();
    alphaRefetch();
    dispatch(roleToggler("Employee"));
  }, []);

  if (isLoading) {
    return (
      <div style={{ backgroundColor: "white", height: "100vh" }}>
        <ProgressBar />;
      </div>
    );
  }

  return (
    <div
      className="employee-shell"
      style={{
        backgroundImage: `url(${data?.data?.bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      {data?.data?.leftIcon && (
        <div className="bookLayout__left">
          <img src={data?.data?.leftIcon} alt="" />
        </div>
      )}
      {data?.data?.rightIcon && (
        <div className="bookLayout__right">
          <img src={data?.data?.rightIcon} alt="" />
        </div>
      )}
      <Navbar
        isTimeTrail={isTimeTrailsPage}
        timeTrailMode={isTimeTrailsPage ? data?.data?.mode : undefined}
      />
      <Outlet />
    </div>
  );
};

export default EmployeeLayout;
